import React from "react";
import { useSelector } from "react-redux";
import logo from "../../assets/images/logo.png";

export default function Navbar({ setShow }) {
  const { totalQuntity } = useSelector((state) => state.product);
  return (
    <>
      {/* <!-- Navbar --> */}
      <nav className="bg-[#171C2A] py-4">
        <div className="navBar">
          <a href="#" onClick={() => setShow(true)} className="cursor-pointer">
            <img src={logo} alt="LWS" className="max-w-[140px]" />
          </a>

          <div className="flex gap-4">
            <a
              onClick={() => setShow(true)}
              className="navHome cursor-pointer"
              id="lws-home"
            >
              {" "}
              Home{" "}
            </a>
            <a
              onClick={() => setShow(false)}
              className="navCart cursor-pointer"
              id="lws-cart"
            >
              <i className="text-xl fa-sharp fa-solid fa-bag-shopping"></i>
              <span id="lws-totalCart">{totalQuntity}</span>
            </a>
          </div>
        </div>
      </nav>
      {/* <!-- Navbar ends --> */}
    </>
  );
}
